import { css } from "@emotion/react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useAccountID } from "../store/account";
import { hidePaidModal, useUi } from "../store/ui";

const modalStyles = {
    content: {
        top: "10%",
        left: "35%",
        right: "35%",
        bottom: "auto"
        //marginRight: "-50%",
        //transform: "translate(-50%, -50%)"
    }
};

export default function PaidModal() {
    const accountID = useAccountID();
    const dispatch = useDispatch();
    const { paid } = useUi(),
        isOpen = !!paid,
        closeModal = () => dispatch(hidePaidModal()),
        dialogContent = paid;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            style={modalStyles}
            contentLabel="Upgrade"
        >
            <div
                css={css`
                    display: flex;
                    & > h1 {
                        margin: 0 0 1rem;
                        font-size: 1.5rem;
                        font-weight: 500;
                        flex: 1;
                        color: #f0592b;
                    }
                `}
            >
                <h1>Premium Feature</h1>
                <div
                    onClick={closeModal}
                    css={css`
                        font-size: 1.5rem;
                        font-weight: 500;
                        color: #999;
                        cursor: pointer;
                        &:hover {
                            color: #000;
                        }
                    `}
                >
                    ×
                </div>
            </div>
            <div
                css={css`
                    max-height: 70vh;
                    overflow: auto;
                    padding-right: 0.5rem;
                `}
            >
                <p>{dialogContent}</p>
                <p>
                    <Link
                        style={{ fontSize: "1.25rem", fontWeight: 500 }}
                        to={`/dashboard/${accountID}/upgrade`}
                        onClick={closeModal}
                    >
                        Learn more ▶
                    </Link>
                </p>
            </div>
        </Modal>
    );
}
